import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from 'assets/icons/scribex-erp-logo.svg';
import image from 'assets/images/admin-sinin.png';
import { Col, Image, Row, Typography } from 'components';
import { ADMIN_ROUTES, WAREHOUSE_ROUTES } from 'constants/routes';
import { SignInForm, SignInFormData } from 'components/auth';
import styles from './styles.module.scss';
import { useAdminSignIn } from './useSignin';

const {Text} = Typography;

export const AdminSignIn = React.memo(() => {
  const navigate = useNavigate();
  const {onFinish, contextHolder, form, isLoading} = useAdminSignIn();

  const handleForgotPassword = () => {
    navigate(ADMIN_ROUTES.adminForgotPassword);
  };

  const handleWarehouseLogin = () => {
    navigate(WAREHOUSE_ROUTES.warehouseSignIn);
  };

  const handleFormSubmit = (values: SignInFormData) => {
    onFinish({
      username: values.username || values.email || '',
      password: values.password,
    } as any);
  };
  return (
    <>
      {contextHolder}
      <Row className={styles.logo}>
        <Image src={logo} alt={'LLogo'} preview={false}/>
      </Row>
      <Row wrap={true} className={styles.signup} align={'middle'}>
        <Col lg={12} md={24}>
          <Row justify={'center'} className={styles.left_side} align={'top'}>
            <Col sm={15} xs={24} className={styles.form}>
              <Row gutter={[0, 24]}>
                <Col span={24}>
                  <Text className={styles.title}>Sign In</Text>
                </Col>
                <Col span={24}>
                  <SignInForm
                    form={form}
                    onFinish={handleFormSubmit}
                    loading={isLoading}
                    usernameField="username"
                    onForgotPassword={handleForgotPassword}
                    submitButtonText="Sign In"
                    forgotPasswordText="Forgot password?"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row justify={'center'} className={styles.erp_link_container}>
            <Col onClick={handleWarehouseLogin}>
              <Text style={{color: '#05796B'}} underline>
                Log in into Warehouse System
              </Text>
            </Col>
          </Row>
        </Col>
        <Col lg={12} md={24}>
          <Row className={styles.right_side}>
            <Image src={image} alt={'image'} preview={false} width={'100%'}/>
            <Row className={styles.logo_in_img}>
              <Image src={logo} alt={'Logo'} preview={false}/>
            </Row>
          </Row>
        </Col>
      </Row>
    </>
  );
});
